import script from "./CryptoRecharge.vue?vue&type=script&setup=true&lang=js"
export * from "./CryptoRecharge.vue?vue&type=script&setup=true&lang=js"

import "./CryptoRecharge.vue?vue&type=style&index=0&id=5a8d9e19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8d9e19"]])

export default __exports__